import React from 'react';
import { i18n } from 'config/locales';

import ValidationElement from 'components/Form/ValidationElement';
import LinkButton from 'components/Form/LinkButton';
import { NameSummary, NameText, DateSummary } from '../../Summary';
import { validDate } from '../History/dateranges';
import SvgComponent from 'components/Form/SvgComponent';

export default class Signature extends ValidationElement {
  constructor(props) {
    super(props);

    this.update = this.update.bind(this);
    this.addSignature = this.addSignature.bind(this);
    this.removeSignature = this.removeSignature.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  update(queue) {
    this.props.onUpdate({
      Name: this.props.Name,
      Date: this.props.Date,
      ...queue,
    });
  }

  addSignature() {
    const now = new Date();
    this.update({
      Name: {
        value: this.name(false),
      },
      Date: {
        date: now,
        month: `${now.getUTCMonth() + 1}`,
        day: `${now.getUTCDate()}`,
        year: `${now.getUTCFullYear()}`,
      },
    });
  }

  removeSignature() {
    this.update({
      Name: {},
      Date: {},
    });
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      code: `signature.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    return this.props.onError(value, arr2);
  }

  name(formatted = true) {
    if ((this.props.Name || {}).value) {
      return formatted ? (
        <span className="title-case">{this.props.Name.value}</span>
      ) : (
        this.props.Name.value
      );
    }

    const legalName = (this.props.LegalName || {}).Name;
    return formatted ? NameSummary(legalName) : NameText(legalName);
  }

  render() {
    const name = this.name();
    const signed = validDate(this.props.Date);
    const button = (
      <button
        className="add"
        type="button"
        onClick={this.addSignature} // eslint-disable-line @typescript-eslint/unbound-method
      >
        {i18n.t('signature.add')}
      </button>
    );
    const nameSummary = signed ? name : button;
    const dateSummary = signed ? DateSummary(this.props.Date, '', true) : '';
    return (
      <div className="signature">
        <span className="name wet">{nameSummary}</span>
        <span className="spacer" />
        <span className="date wet">{dateSummary}</span>
        <span className="name muted">{i18n.t('signature.name')}</span>
        <span className="spacer" />
        <span className="date muted">{i18n.t('signature.date')}</span>
        {signed
          && (
            <LinkButton
              classContent="remove"
              ignoreLinkStyle
              onClick={() => this.removeSignature()}
            >
              <span>{i18n.t('signature.remove')}</span>
              <div className="cross-circle" aria-hidden="true">
                <SvgComponent className="cross-circle" src="/img/cross-circle.svg" />
              </div>
            </LinkButton>
          )}
      </div>
    );
  }
}

Signature.defaultProps = {
  Name: {},
  Date: {},
  LegalName: {},
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};
